var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "clientNav", attrs: { id: "topNav" } },
    [
      _c(
        "router-link",
        { staticClass: "systemName", attrs: { to: { name: "clientHome" } } },
        [_vm._v(_vm._s(_vm.title))]
      ),
      _vm._v(" "),
      _vm.isAdmin
        ? _c(
            "router-link",
            { staticClass: "adminHome", attrs: { to: { name: "adminHome" } } },
            [_vm._v("Admin")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "logoutButton",
          attrs: { role: "button" },
          on: { click: _vm.logoutClicked }
        },
        [_vm._v("Log Out")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }